import { render } from "./TimezoneDropdown.vue?vue&type=template&id=b13aa468"
import script from "./TimezoneDropdown.vue?vue&type=script&lang=js"
export * from "./TimezoneDropdown.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__